// extracted by mini-css-extract-plugin
export default {"content":"ConfirmModals_content__pvswQ","list":"ConfirmModals_list__LCSK6","item":"ConfirmModals_item__gJmad"};